import { useEffect, useState } from 'react';
import { Alert, Modal, Pressable, Text, View, type AlertButton } from 'react-native';
import { C } from '../components/theme';

// O navegador da prévia bloqueia alert()/confirm(); os avisos do app aparecem nesta janela própria.
type Aviso = { title: string; msg?: string; buttons: AlertButton[] };
let mostrar: ((a: Aviso) => void) | null = null;
(Alert as any).alert = (title: string, msg?: string, buttons?: AlertButton[]) =>
  mostrar?.({ title, msg, buttons: buttons?.length ? buttons : [{ text: 'OK' }] });

export function PlatformHost() {
  const [a, setA] = useState<Aviso | null>(null);
  useEffect(() => { mostrar = setA; return () => { mostrar = null; }; }, []);
  if (!a) return null;
  return (
    <Modal transparent animationType="fade" onRequestClose={() => { setA(null); a.buttons.find(b => b.style === 'cancel')?.onPress?.(); }}>
      <View style={{ flex: 1, backgroundColor: C.overlay, justifyContent: 'center', alignItems: 'center', padding: 28 }}>
        <View style={{ backgroundColor: C.card, borderRadius: 20, padding: 20, gap: 10, width: '100%', maxWidth: 440 }}>
          <Text style={{ color: C.text, fontWeight: '800', fontSize: 17 }}>{a.title}</Text>
          {!!a.msg && <Text style={{ color: C.sub, fontSize: 14 }}>{a.msg}</Text>}
          <View style={{ flexDirection: 'row', justifyContent: 'flex-end', flexWrap: 'wrap', gap: 18, marginTop: 8 }}>
            {a.buttons.map((b, i) => (
              <Pressable key={i} onPress={() => { setA(null); b.onPress?.(); }}>
                <Text style={{ fontSize: 15, fontWeight: '700', color: b.style === 'destructive' ? C.danger : b.style === 'cancel' ? C.sub : '#A78BFA' }}>{b.text}</Text>
              </Pressable>
            ))}
          </View>
        </View>
      </View>
    </Modal>
  );
}
